/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var updateCellInfo = produce(function (draft, action) {
  var cellId = action.payload.cellId;
  draft.cellId = cellId;
}, initialState);
export default updateCellInfo;